import { observer } from '@rehaje/reactive-react'

import type { JavaScriptNode } from './TypedNode'
import type { ViewComponent } from '@rehaje/react'

export const JavaScriptComponent: ViewComponent<JavaScriptNode> = observer(
  ({ node }) => {
    return node.transpile(node.__r_ensureViewElement().scope, true)
  }
)
